// extracted by mini-css-extract-plugin
module.exports = {"container":"Navbar_container__20fRR","left":"Navbar_left__7Qb60","right":"Navbar_right__xP8Ob","back":"Navbar_back__1DQwH","title":"Navbar_title__1WI16"};